import PropTypes from "prop-types"
import TradesPanel from "components/trades-panel"

function RebalanceTrades({
  selectedDate,
  portfolioName,
  status,
  fileName,
  csvRows,
  tradeType,
  trades,
  openSecurityProfile,
  openCompositeSecurity,
  setOpenTradeId,
  openTradeId,
  openFactorProfile,
  toggleTrades,
  tradesOpened,
  setTradeType,
  toggleSaveExperiment,
  saveDisabled,
}) {
  return <TradesPanel
    {...{
      selectedDate,
      portfolioName,
      status,
      fileName,
      setTradeType,
      csvRows,
      tradeType,
      trades,
      openSecurityProfile,
      openCompositeSecurity,
      setOpenTradeId,
      openTradeId,
      openFactorProfile,
      toggleTrades,
      tradesOpened,
      toggleSaveExperiment,
      saveEnabled: !saveDisabled,
    }}
  />
}

RebalanceTrades.propTypes = {
  selectedDate: PropTypes.string.isRequired,
  portfolioName: PropTypes.string.isRequired,
  status: PropTypes.string.isRequired,
  fileName: PropTypes.string.isRequired,
  csvRows: PropTypes.array.isRequired,
  tradeType: PropTypes.string.isRequired,
  trades: PropTypes.array.isRequired,
  openSecurityProfile: PropTypes.func.isRequired,
  openCompositeSecurity: PropTypes.func.isRequired,
  setOpenTradeId: PropTypes.func.isRequired,
  openTradeId: PropTypes.string,
  openFactorProfile: PropTypes.func.isRequired,
  toggleTrades: PropTypes.func.isRequired,
  tradesOpened: PropTypes.bool.isRequired,
  saveDisabled: PropTypes.bool,
  setTradeType: PropTypes.func.isRequired,
  toggleSaveExperiment: PropTypes.func.isRequired,
}

export default RebalanceTrades
